import { render, staticRenderFns } from "./TileDataBEMoWPersonen.vue?vue&type=template&id=2456cd18"
import script from "./TileDataBEMoWPersonen.vue?vue&type=script&lang=js"
export * from "./TileDataBEMoWPersonen.vue?vue&type=script&lang=js"
import style0 from "./TileDataBEMoWPersonen.vue?vue&type=style&index=0&id=2456cd18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports